<template>
<div>
    <v-btn
    icon
    :loading="generandoMinuta"
    @click="generarMinutaPdf()"
    >
    <v-icon color="primary">mdi-file-pdf-box</v-icon>
    </v-btn>
</div>

</template>
<script>
import CONTRATO_MINUTAS_ACUERDOS from '@/graphql/querys/administracion/minutas/contratoMinutasAcuerdos.gql';
import CONTRATO_MINUTA_ASUNTOS_PDF from '@/graphql/querys/administracion/minutas/contratoMinutaAsuntosPdf.gql';
import CONTRATO_MINUTA_PDF from '@/graphql/querys/administracion/minutas/contratoMinutaPdf.gql';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';

export default {
  name: 'PdfMinuta',
  props: {
    idMinuta: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      generandoMinuta: false,
      loading: false,
      getMinutaPdf: {},
      getAsuntosPdf: [],
      getContratoMinutasAcuerdos: [],
    };
  },
  mixins: [mixGenerarPdf],
  methods: {
    async generarMinutaPdf() {
      this.generandoMinuta = true;

      // Lee Datos de la Minuta y Contrato
      const responseMinuta = await this.$apollo.query({
        query: CONTRATO_MINUTA_PDF,
        variables: { idMinuta: this.idMinuta },

      })
        .catch((err) => {
          this.mixMensajeError(err);
          this.generandoMinuta = false;
        });
      this.getMinutaPdf = responseMinuta.data.contratoMinuta;

      // Lee Acuerdos
      const responseAcuerdos = await this.$apollo.query({
        query: CONTRATO_MINUTAS_ACUERDOS,
        variables: { idMinuta: this.idMinuta },

      })
        .catch((err) => {
          this.mixMensajeError(err);
          this.generandoMinuta = false;
        });
      this.getContratoMinutasAcuerdos = responseAcuerdos.data.contratoMinutasAcuerdos
        .slice()
        .sort((a, b) => a.numero - b.numero);

      // Lee Asuntos
      const responseAsuntos = await this.$apollo.query({
        query: CONTRATO_MINUTA_ASUNTOS_PDF,
        variables: { idMinuta: this.idMinuta },
        fetchPolicy: 'network-only',

      })
        .catch((err) => {
          this.mixMensajeError(err);
          this.generandoMinuta = false;
        });
      this.getAsuntosPdf = responseAsuntos.data.contratoMinutaAsuntosPdf;

      const nombreTemplate = 'templateContratoMinuta';
      const minutaFecha = this.getMinutaPdf.fechaHora.split('T')[0] || '';
      const encabezadoReferencia = this
        .mixGeneraEncabezadosPdf(`${minutaFecha} 00:00:0`, []);
      const numero = this.getMinutaPdf.numero || '';
      const meta = this.getMinutaPdf.contrato.meta.substr(0, 230) || '';
      const tieneAsuntos = this.getAsuntosPdf.length || 0;
      const asuntos = this.getAsuntosPdf || [];
      const participantes = this.getMinutaParticipantes || [];
      const supervisionExterna = this.getContratoSupervisionExterna || '';
      const contrato = this.getContratoContratista || '';
      const textoLugar = this.getTextoLugar || '';
      const textoPrevioContratos = this.getTextoPrevioContratos || '';
      const tieneAcuerdos = this.getContratoMinutasAcuerdos.length || 0;
      const acuerdos = this.getContratoMinutasAcuerdos || [];
      const nombreArchivo = `${this.getMinutaPdf?.numero || ''}_${this.getMinutaPdf.contrato?.numero || 'SinContrato'}`;
      if (tieneAsuntos > 0 || tieneAcuerdos > 0) {
        await this.mixGenerarPdf({
          configuracion: {
            path: 'wepp/wep',
            PUPPETEER_CONFIGURACION: {
              landscape: false,
              format: 'A3',
              /*
              footerTemplate: `<div style="width:100%; font-size:10px; text-align:center;">
                Página <span class="pageNumber"></span>de<span class="totalPages"></span></div>`,
              margin: {
                top: '0mm', botton: '80mm', left: '0mm', right: '0mm',
              },
              */
              printBackground: true,
              displayHeaderFooter: false,
            },
            nombreTemplate,
          },
          data: {
            numero,
            meta,
            tieneAsuntos,
            asuntos,
            participantes,
            supervisionExterna,
            contrato,
            textoLugar,
            textoPrevioContratos,
            encabezadoReferencia,
            tieneAcuerdos,
            acuerdos,
          // footer: '',
          },
        }, `Minuta_${nombreArchivo}`);
      }
      this.generandoMinuta = false;
    },
    formatoFechaTexto(fecha) {
      if (fecha !== null && fecha !== '') {
        const fechaConFormato = new Date(`${fecha} 00:00:0`)
          .toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
        return fechaConFormato;
      }
      return '';
    },
  },
  computed: {
    getMinutaParticipantes() {
      if (!this.getMinutaPdf) return [];
      return this.getMinutaPdf.participantes
        .slice()
        .sort((a, b) => a.nombre.localeCompare(b.nombre)) || [];
    },
    getContratoSupervisionExterna() {
      const contratoRelacionado = this.getMinutaPdf.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
      const supervisionExternaRazonSocial = contratoRelacionado
        ?.contratoRelacionado
        ?.contratista?.nombreRazonSocial || '';
      const supervisionExternaNumero = contratoRelacionado
        ?.contratoRelacionado
        ?.numero || '';
      return `EMPRESA DE SUPERVISIÓN EXTERNA: ${supervisionExternaNumero} - ${supervisionExternaRazonSocial}`;
    },
    getContratoContratista() {
      const contratistaRazonSocial = this.getMinutaPdf.contrato
        ?.contratista?.nombreRazonSocial || '';
      const contratoNumero = this.getMinutaPdf.contrato
        ?.numero || '';
      return `EMPRESA CONSTRUCTORA: ${contratoNumero} - ${contratistaRazonSocial}`;
    },
    getTextoLugar() {
      const fecha = this.getMinutaPdf.fechaHora.substr(0, 10) || '';
      const hora = this.getMinutaPdf.fechaHora.substr(11, 5) || '';
      const lugar = this.getMinutaPdf.lugar || '';
      const texto = `En la ciudad de Hermosillo, Sonora siendo las ${hora} horas del día ${this.formatoFechaTexto(fecha)} se reunen
      en ${lugar.substr(0, 120)} las personas firmantes.`;
      return texto;
    },
    getTextoPrevioContratos() {
      return 'Los contratos y contratistas que ejecutan esta obra son los siguientes:';
    },

  },
};
</script>
